[
  {
    "tag": "1",
    "name": "Account",
    "type": "char",
    "description": "Account mnemonic as agreed between broker and institution."
  },
  {
    "tag": "2",
    "name": "AdvId",
    "type": "int",
    "description": "Unique identifier of advertisement message"
  },
  {
    "tag": "3",
    "name": "AdvRefID",
    "type": "int",
    "description": "Reference identifier used with CANCEL and REPLACE transaction types."
  },
  {
    "tag": "4",
    "name": "AdvSide",
    "type": "char",
    "description": "Broker's side of advertised trade",
    "enum": [
      {
        "value": "B",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "S",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "T",
        "symbolicName": "Trade",
        "description": "Trade"
      },
      {
        "value": "X",
        "symbolicName": "Cross",
        "description": "Cross"
      }
    ]
  },
  {
    "tag": "5",
    "name": "AdvTransType",
    "type": "char",
    "description": "Identifies advertisement message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "6",
    "name": "AvgPx",
    "type": "float",
    "description": "Calculated average price of all fills on this order."
  },
  {
    "tag": "7",
    "name": "BeginSeqNo",
    "type": "int",
    "description": "Message sequence number of first record in range to be resent"
  },
  {
    "tag": "8",
    "name": "BeginString",
    "type": "char",
    "description": "Identifies beginning of new message and protocol version. ALWAYS FIRST FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "9",
    "name": "BodyLength",
    "type": "int",
    "description": "Message length, in bytes, forward to the CheckSum field. ALWAYS SECOND FIELD IN MESSAGE. (Always unencrypted)"
  },
  {
    "tag": "10",
    "name": "CheckSum",
    "type": "char",
    "description": "Three byte, simple checksum (see Appendix B for description). ALWAYS LAST FIELD IN RECORD; i.e. serves, with the trailing <SOH>, as the end-of-record delimiter. Always defined as three characters. (Always unencrypted)"
  },
  {
    "tag": "11",
    "name": "ClOrdID",
    "type": "char",
    "description": "Unique identifier for Order as assigned by institution. Uniqueness must be guaranteed within a single trading day. Firms which electronically submit multi-day orders should consider embedding a date within the ClOrderID field to assure uniqueness across days."
  },
  {
    "tag": "12",
    "name": "Commission",
    "type": "float",
    "description": "Commission"
  },
  {
    "tag": "13",
    "name": "CommType",
    "type": "char",
    "description": "Commission type",
    "enum": [
      {
        "value": "1",
        "symbolicName": "PerUnit",
        "description": "per share"
      },
      {
        "value": "2",
        "symbolicName": "Percent",
        "description": "percentage"
      },
      {
        "value": "3",
        "symbolicName": "Absolute",
        "description": "absolute"
      }
    ]
  },
  {
    "tag": "14",
    "name": "CumQty",
    "type": "int",
    "description": "Total number of shares filled.\nValid values:\n(0 - 1000000000)"
  },
  {
    "tag": "15",
    "name": "Currency",
    "type": "char",
    "description": "Identifies currency used for price, Absence of this field in a message is interpreted as US dollars. See Appendix A for information on obtaining valid values."
  },
  {
    "tag": "16",
    "name": "EndSeqNo",
    "type": "int",
    "description": "Message sequence number of last record in range to be resent. If request is for a single record BeginSeqNo = EndSeqNo. If request is for all messages subsequent to a particular message, EndSeqNo = \"999999\""
  },
  {
    "tag": "17",
    "name": "ExecID",
    "type": "int",
    "description": "Unique identifier of execution message as assigned by broker (will be 0 (zero) for ExecTransType=3 (Status)).\nUniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the ExecID field to assure uniqueness across days."
  },
  {
    "tag": "18",
    "name": "ExecInst",
    "type": "char",
    "description": "Instructions for order handling on exchange trading floor. If more than one instruction is applicable to an order, this field can contain multiple instructions separated by space.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "StayOnOfferSide",
        "description": "Stay on offerside"
      },
      {
        "value": "1",
        "symbolicName": "NotHeld",
        "description": "Not held"
      },
      {
        "value": "2",
        "symbolicName": "Work",
        "description": "Work"
      },
      {
        "value": "3",
        "symbolicName": "GoAlong",
        "description": "Go along"
      },
      {
        "value": "4",
        "symbolicName": "OverTheDay",
        "description": "Over the day"
      },
      {
        "value": "5",
        "symbolicName": "Held",
        "description": "Held"
      },
      {
        "value": "6",
        "symbolicName": "ParticipateDoNotInitiate",
        "description": "Participate don't initiate"
      },
      {
        "value": "7",
        "symbolicName": "StrictScale",
        "description": "Strict scale"
      },
      {
        "value": "8",
        "symbolicName": "TryToScale",
        "description": "Try to scale"
      },
      {
        "value": "9",
        "symbolicName": "StayOnBidSide",
        "description": "Stay on bidside"
      },
      {
        "value": "A",
        "symbolicName": "NoCross",
        "description": "No cross"
      },
      {
        "value": "B",
        "symbolicName": "OKToCross",
        "description": "OK to cross"
      },
      {
        "value": "C",
        "symbolicName": "CallFirst",
        "description": "Call first"
      },
      {
        "value": "D",
        "symbolicName": "PercentOfVolume",
        "description": "Percent of volume"
      },
      {
        "value": "E",
        "symbolicName": "DoNotIncrease",
        "description": "Do not increase - DNI"
      },
      {
        "value": "F",
        "symbolicName": "DoNotReduce",
        "description": "Do not reduce - DNR"
      },
      {
        "value": "G",
        "symbolicName": "AllOrNone",
        "description": "All or none - AON"
      },
      {
        "value": "I",
        "symbolicName": "InstitutionsOnly",
        "description": "Institutions only"
      },
      {
        "value": "L",
        "symbolicName": "LastPeg",
        "description": "Last peg (last sale)"
      },
      {
        "value": "M",
        "symbolicName": "MidPricePeg",
        "description": "Mid-price peg (midprice of inside quote)"
      },
      {
        "value": "N",
        "symbolicName": "NonNegotiable",
        "description": "Non-negotiable"
      },
      {
        "value": "O",
        "symbolicName": "OpeningPeg",
        "description": "Opening peg"
      },
      {
        "value": "P",
        "symbolicName": "MarketPeg",
        "description": "Market peg"
      },
      {
        "value": "R",
        "symbolicName": "PrimaryPeg",
        "description": "Primary peg (primary market - buy at bid/sell at offer)"
      },
      {
        "value": "S",
        "symbolicName": "Suspend",
        "description": "Suspend"
      }
    ]
  },
  {
    "tag": "19",
    "name": "ExecRefID",
    "type": "int",
    "description": "Reference identifier used with Cancel and Correct transaction types."
  },
  {
    "tag": "20",
    "name": "ExecTransType",
    "type": "char",
    "description": "Identifies transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "2",
        "symbolicName": "Correct",
        "description": "Correct"
      },
      {
        "value": "3",
        "symbolicName": "Status",
        "description": "Status"
      }
    ]
  },
  {
    "tag": "21",
    "name": "HandlInst",
    "type": "char",
    "description": "Instructions for order handling on Broker trading floor",
    "enum": [
      {
        "value": "1",
        "symbolicName": "AutomatedExecutionNoIntervention",
        "description": "Automated execution order, private, no Broker intervention"
      },
      {
        "value": "2",
        "symbolicName": "AutomatedExecutionInterventionOK",
        "description": "Automated execution order, public, Broker intervention OK"
      },
      {
        "value": "3",
        "symbolicName": "ManualOrder",
        "description": "Manual order, best execution"
      }
    ]
  },
  {
    "tag": "22",
    "name": "IDSource",
    "type": "char",
    "description": "Identifies class of alternative SecurityID\n100+ are reserved for private security identifications",
    "enum": [
      {
        "value": "1",
        "symbolicName": "CUSIP",
        "description": "CUSIP"
      },
      {
        "value": "2",
        "symbolicName": "SEDOL",
        "description": "SEDOL"
      },
      {
        "value": "3",
        "symbolicName": "QUIK",
        "description": "QUIK"
      },
      {
        "value": "4",
        "symbolicName": "ISINNumber",
        "description": "ISIN number"
      },
      {
        "value": "5",
        "symbolicName": "RICCode",
        "description": "RIC code"
      }
    ]
  },
  {
    "tag": "23",
    "name": "IOIid",
    "type": "int",
    "description": "Unique identifier of IOI message."
  },
  {
    "tag": "24",
    "name": "IOIOthSvc",
    "type": "char",
    "description": "Indicates if, and on which other services, the indication has been advertised. Each character represents an additional service (e.g. if on Bridge and Autex, field = BA, if only on Autex, field = A)",
    "enum": [
      {
        "value": "A",
        "symbolicName": "Autex",
        "description": "Autex"
      },
      {
        "value": "B",
        "symbolicName": "Bridge",
        "description": "Bridge"
      }
    ]
  },
  {
    "tag": "25",
    "name": "IOIQltyInd",
    "type": "char",
    "description": "Relative quality of indication",
    "enum": [
      {
        "value": "H",
        "symbolicName": "High",
        "description": "High"
      },
      {
        "value": "L",
        "symbolicName": "Low",
        "description": "Low"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      }
    ]
  },
  {
    "tag": "26",
    "name": "IOIRefID",
    "type": "int",
    "description": "Reference identifier used with CANCEL and REPLACE, transaction types."
  },
  {
    "tag": "27",
    "name": "IOIShares",
    "type": "char",
    "description": "Number of shares in numeric or relative size.",
    "enum": [
      {
        "value": "L",
        "symbolicName": "Large",
        "description": "Large"
      },
      {
        "value": "M",
        "symbolicName": "Medium",
        "description": "Medium"
      },
      {
        "value": "S",
        "symbolicName": "Small",
        "description": "Small"
      }
    ]
  },
  {
    "tag": "28",
    "name": "IOITransType",
    "type": "char",
    "description": "Identifies IOI message transaction type",
    "enum": [
      {
        "value": "C",
        "symbolicName": "Cancel",
        "description": "Cancel"
      },
      {
        "value": "N",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "R",
        "symbolicName": "Replace",
        "description": "Replace"
      }
    ]
  },
  {
    "tag": "29",
    "name": "LastCapacity",
    "type": "char",
    "description": "Broker capacity in order execution",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Agent",
        "description": "Agent"
      },
      {
        "value": "2",
        "symbolicName": "CrossAsAgent",
        "description": "Cross as agent"
      },
      {
        "value": "3",
        "symbolicName": "CrossAsPrincipal",
        "description": "Cross as principal"
      },
      {
        "value": "4",
        "symbolicName": "Principal",
        "description": "Principal"
      }
    ]
  },
  {
    "tag": "30",
    "name": "LastMkt",
    "type": "char",
    "description": "Market of execution for last fill\nValid values:\nSee Appendix C"
  },
  {
    "tag": "31",
    "name": "LastPx",
    "type": "float",
    "description": "Price of last fill. Field not required for ExecTransType = 3 (Status)"
  },
  {
    "tag": "32",
    "name": "LastShares",
    "type": "int",
    "description": "Quantity of shares bought/sold on this fill. Field not required for ExecTransType = 3 (Status)"
  },
  {
    "tag": "33",
    "name": "LinesOfText",
    "type": "int",
    "description": "Identifies number of lines of text body"
  },
  {
    "tag": "34",
    "name": "MsgSeqNum",
    "type": "int",
    "description": "Integer message sequence number."
  },
  {
    "tag": "35",
    "name": "MsgType",
    "type": "char",
    "description": "Defines message type. ALWAYS THIRD FIELD IN MESSAGE. (Always unencrypted)\nNote: A \"U\" as the first character in the MsgType field indicates that the message format is privately defined between the sender and receiver.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Heartbeat",
        "description": "Heartbeat"
      },
      {
        "value": "1",
        "symbolicName": "TestRequest",
        "description": "Test Request"
      },
      {
        "value": "2",
        "symbolicName": "ResendRequest",
        "description": "Resend Request"
      },
      {
        "value": "3",
        "symbolicName": "Reject",
        "description": "Reject"
      },
      {
        "value": "4",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset"
      },
      {
        "value": "5",
        "symbolicName": "Logout",
        "description": "Logout"
      },
      {
        "value": "6",
        "symbolicName": "IOI",
        "description": "Indication of Interest"
      },
      {
        "value": "7",
        "symbolicName": "Advertisement",
        "description": "Advertisement"
      },
      {
        "value": "8",
        "symbolicName": "ExecutionReport",
        "description": "Execution Report"
      },
      {
        "value": "9",
        "symbolicName": "OrderCancelReject",
        "description": "Order Cancel Reject"
      },
      {
        "value": "A",
        "symbolicName": "Logon",
        "description": "Logon"
      },
      {
        "value": "B",
        "symbolicName": "News",
        "description": "News"
      },
      {
        "value": "C",
        "symbolicName": "Email",
        "description": "Email"
      },
      {
        "value": "D",
        "symbolicName": "NewOrderSingle",
        "description": "Order - Single"
      },
      {
        "value": "E",
        "symbolicName": "NewOrderList",
        "description": "Order - List"
      },
      {
        "value": "F",
        "symbolicName": "OrderCancelRequest",
        "description": "Order Cancel Request"
      },
      {
        "value": "G",
        "symbolicName": "OrderCancelReplaceRequest",
        "description": "Order Cancel/Replace Request"
      },
      {
        "value": "H",
        "symbolicName": "OrderStatusRequest",
        "description": "Order Status Request"
      },
      {
        "value": "J",
        "symbolicName": "AllocationInstruction",
        "description": "Allocation"
      },
      {
        "value": "K",
        "symbolicName": "ListCancelRequest",
        "description": "List Cancel Request"
      },
      {
        "value": "L",
        "symbolicName": "ListExecute",
        "description": "List Execute"
      },
      {
        "value": "M",
        "symbolicName": "ListStatusRequest",
        "description": "List Status Request"
      },
      {
        "value": "N",
        "symbolicName": "ListStatus",
        "description": "List Status"
      },
      {
        "value": "P",
        "symbolicName": "AllocationInstructionAck",
        "description": "Allocation ACK"
      },
      {
        "value": "Q",
        "symbolicName": "DontKnowTrade",
        "description": "Dont Know Trade (DK)"
      },
      {
        "value": "R",
        "symbolicName": "QuoteRequest",
        "description": "Quote Request"
      },
      {
        "value": "S",
        "symbolicName": "Quote",
        "description": "Quote"
      }
    ]
  },
  {
    "tag": "36",
    "name": "NewSeqNo",
    "type": "int",
    "description": "New sequence number\nValid values:\n0 - 999999"
  },
  {
    "tag": "37",
    "name": "OrderID",
    "type": "char",
    "description": "Unique identifier for Order as assigned by broker. Uniqueness must be guaranteed within a single trading day. Firms which accept multi-day orders should consider embedding a date within the OrderID field to assure uniqueness across days."
  },
  {
    "tag": "38",
    "name": "OrderQty",
    "type": "int",
    "description": "Number of shares ordered"
  },
  {
    "tag": "39",
    "name": "OrdStatus",
    "type": "char",
    "description": "Identifies current status of order.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "PartiallyFilled",
        "description": "Partially filled"
      },
      {
        "value": "2",
        "symbolicName": "Filled",
        "description": "Filled"
      },
      {
        "value": "3",
        "symbolicName": "DoneForDay",
        "description": "Done for day"
      },
      {
        "value": "4",
        "symbolicName": "Canceled",
        "description": "Canceled"
      },
      {
        "value": "5",
        "symbolicName": "Replaced",
        "description": "Replaced"
      },
      {
        "value": "6",
        "symbolicName": "PendingCancel",
        "description": "Pending Cancel/Replace"
      },
      {
        "value": "7",
        "symbolicName": "Stopped",
        "description": "Stopped"
      },
      {
        "value": "8",
        "symbolicName": "Rejected",
        "description": "Rejected"
      },
      {
        "value": "9",
        "symbolicName": "Suspended",
        "description": "Suspended"
      },
      {
        "value": "A",
        "symbolicName": "PendingNew",
        "description": "Pending New"
      },
      {
        "value": "B",
        "symbolicName": "Calculated",
        "description": "Calculated"
      },
      {
        "value": "C",
        "symbolicName": "Expired",
        "description": "Expired"
      }
    ]
  },
  {
    "tag": "40",
    "name": "OrdType",
    "type": "char",
    "description": "Order type.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Market",
        "description": "Market"
      },
      {
        "value": "2",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "3",
        "symbolicName": "Stop",
        "description": "Stop"
      },
      {
        "value": "4",
        "symbolicName": "StopLimit",
        "description": "Stop limit"
      },
      {
        "value": "5",
        "symbolicName": "MarketOnClose",
        "description": "Market on close"
      },
      {
        "value": "6",
        "symbolicName": "WithOrWithout",
        "description": "With or without"
      },
      {
        "value": "7",
        "symbolicName": "LimitOrBetter",
        "description": "Limit or better"
      },
      {
        "value": "8",
        "symbolicName": "LimitWithOrWithout",
        "description": "Limit with or without"
      },
      {
        "value": "9",
        "symbolicName": "OnBasis",
        "description": "On basis"
      },
      {
        "value": "A",
        "symbolicName": "OnClose",
        "description": "On close"
      },
      {
        "value": "B",
        "symbolicName": "LimitOnClose",
        "description": "Limit on close"
      },
      {
        "value": "C",
        "symbolicName": "ForexMarket",
        "description": "Forex"
      },
      {
        "value": "D",
        "symbolicName": "PreviouslyQuoted",
        "description": "Previously quoted"
      },
      {
        "value": "E",
        "symbolicName": "PreviouslyIndicated",
        "description": "Previously indicated"
      },
      {
        "value": "P",
        "symbolicName": "Pegged",
        "description": "Pegged (requires ExecInst = L, R, M, P or O)"
      }
    ]
  },
  {
    "tag": "41",
    "name": "OrigClOrdID",
    "type": "char",
    "description": "Original order id as assigned by the institution, used to identify original order in cancel and cancel/replace requests."
  },
  {
    "tag": "42",
    "name": "OrigTime",
    "type": "time",
    "description": "Time of message origination (always expressed in GMT)"
  },
  {
    "tag": "43",
    "name": "PossDupFlag",
    "type": "char",
    "description": "Indicates possible retransmission of message with this sequence number",
    "enum": [
      {
        "value": "N",
        "symbolicName": "OriginalTransmission",
        "description": "Original transmission"
      },
      {
        "value": "Y",
        "symbolicName": "PossibleDuplicate",
        "description": "Possible duplicate"
      }
    ]
  },
  {
    "tag": "44",
    "name": "Price",
    "type": "float",
    "description": "Price per share"
  },
  {
    "tag": "45",
    "name": "RefSeqNum",
    "type": "int",
    "description": "Reference message sequence number"
  },
  {
    "tag": "46",
    "name": "RelatdSym",
    "type": "char",
    "description": "Symbol of issue related to story. Can be repeated within message to identify multiple companies."
  },
  {
    "tag": "47",
    "name": "Rule80A",
    "type": "char",
    "description": "Indicates order type upon which exchange Rule 80A is applied.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AgencySingleOrder",
        "description": "Agency single order"
      },
      {
        "value": "C",
        "symbolicName": "ProprietaryNonAlgo",
        "description": "Program Order, non-index arb, for Member firm/org"
      },
      {
        "value": "D",
        "symbolicName": "ProgramOrderMember",
        "description": "Program Order, index arb, for Member firm/org"
      },
      {
        "value": "I",
        "symbolicName": "IndividualInvestor",
        "description": "Individual Investor, single order"
      },
      {
        "value": "J",
        "symbolicName": "ProprietaryAlgo",
        "description": "Program Order, index arb, for individual customer"
      },
      {
        "value": "K",
        "symbolicName": "AgencyAlgo",
        "description": "Program Order, non-index arb, for individual customer"
      },
      {
        "value": "M",
        "symbolicName": "ProgramOrderOtherMember",
        "description": "Program Order, index arb, for other member"
      },
      {
        "value": "N",
        "symbolicName": "AgentForOtherMember",
        "description": "Program Order, non-index arb, for other member"
      },
      {
        "value": "U",
        "symbolicName": "AgencyIndexArb",
        "description": "Program Order, index arb, for other agency"
      },
      {
        "value": "W",
        "symbolicName": "AllOtherOrdersAsAgentForOtherMember",
        "description": "All other orders as agent for other member"
      },
      {
        "value": "Y",
        "symbolicName": "AgencyNonAlgo",
        "description": "Program Order, non-index arb, for other agency"
      }
    ]
  },
  {
    "tag": "48",
    "name": "SecurityID",
    "type": "char",
    "description": "CUSIP or other alternate security identifier"
  },
  {
    "tag": "49",
    "name": "SenderCompID",
    "type": "char",
    "description": "Assigned value used to identify firm sending message."
  },
  {
    "tag": "50",
    "name": "SenderSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.)"
  },
  {
    "tag": "52",
    "name": "SendingTime",
    "type": "time",
    "description": "Time of message transmission (always expressed in GMT)"
  },
  {
    "tag": "53",
    "name": "Shares",
    "type": "int",
    "description": "Number of shares"
  },
  {
    "tag": "54",
    "name": "Side",
    "type": "char",
    "description": "Side of order",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Buy",
        "description": "Buy"
      },
      {
        "value": "2",
        "symbolicName": "Sell",
        "description": "Sell"
      },
      {
        "value": "3",
        "symbolicName": "BuyMinus",
        "description": "Buy minus"
      },
      {
        "value": "4",
        "symbolicName": "SellPlus",
        "description": "Sell plus"
      },
      {
        "value": "5",
        "symbolicName": "SellShort",
        "description": "Sell short"
      },
      {
        "value": "6",
        "symbolicName": "SellShortExempt",
        "description": "Sell short exempt"
      }
    ]
  },
  {
    "tag": "55",
    "name": "Symbol",
    "type": "char",
    "description": "Ticker symbol"
  },
  {
    "tag": "56",
    "name": "TargetCompID",
    "type": "char",
    "description": "Assigned value used to identify receiving firm."
  },
  {
    "tag": "57",
    "name": "TargetSubID",
    "type": "char",
    "description": "Assigned value used to identify specific individual or unit intended to receive message. \"ADMIN\" reserved for administrative messages not intended for a specific user."
  },
  {
    "tag": "58",
    "name": "Text",
    "type": "char",
    "description": "Free format text string"
  },
  {
    "tag": "59",
    "name": "TimeInForce",
    "type": "char",
    "description": "Specifies how long the order remains in effect. Absence of this field is interpreted as DAY.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Day",
        "description": "Day"
      },
      {
        "value": "1",
        "symbolicName": "GoodTillCancel",
        "description": "Good Till Cancel (GTC)"
      },
      {
        "value": "2",
        "symbolicName": "AtTheOpening",
        "description": "At the Opening (OPG)"
      },
      {
        "value": "3",
        "symbolicName": "ImmediateOrCancel",
        "description": "Immediate or Cancel (OC)"
      },
      {
        "value": "4",
        "symbolicName": "FillOrKill",
        "description": "Fill or Kill (FOK)"
      },
      {
        "value": "5",
        "symbolicName": "GoodTillCrossing",
        "description": "Good Till Crossing (GTX)"
      },
      {
        "value": "6",
        "symbolicName": "GoodTillDate",
        "description": "Good Till Date"
      }
    ]
  },
  {
    "tag": "60",
    "name": "TransactTime",
    "type": "time",
    "description": "Time of execution/order creation (expressed in GMT)"
  },
  {
    "tag": "61",
    "name": "Urgency",
    "type": "char",
    "description": "Urgency flag",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Normal",
        "description": "Normal"
      },
      {
        "value": "1",
        "symbolicName": "Flash",
        "description": "Flash"
      },
      {
        "value": "2",
        "symbolicName": "Background",
        "description": "Background"
      }
    ]
  },
  {
    "tag": "62",
    "name": "ValidUntilTime",
    "type": "time",
    "description": "Indicates expiration time of indication message (always expressed in GMT)"
  },
  {
    "tag": "63",
    "name": "SettlmntTyp",
    "type": "char",
    "description": "Indicates order settlement period. Absence of this field is interpreted as Regular. Regular is defined as the default settlement period for the particular security on the exchange of execution.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "Regular"
      },
      {
        "value": "1",
        "symbolicName": "Cash",
        "description": "Cash"
      },
      {
        "value": "2",
        "symbolicName": "NextDay",
        "description": "Next Day"
      },
      {
        "value": "3",
        "symbolicName": "TPlus2",
        "description": "T+2"
      },
      {
        "value": "4",
        "symbolicName": "TPlus3",
        "description": "T+3"
      },
      {
        "value": "5",
        "symbolicName": "TPlus4",
        "description": "T+4"
      },
      {
        "value": "6",
        "symbolicName": "Future",
        "description": "Future"
      },
      {
        "value": "7",
        "symbolicName": "WhenAndIfIssued",
        "description": "When Issued"
      },
      {
        "value": "8",
        "symbolicName": "SellersOption",
        "description": "Sellers Option"
      },
      {
        "value": "9",
        "symbolicName": "TPlus5",
        "description": "T+ 5"
      }
    ]
  },
  {
    "tag": "64",
    "name": "FutSettDate",
    "type": "date",
    "description": "Specific date of trade settlement in YYYYMMDD format. Required when SettlmntTyp = 6 (Future) or SettlmntTyp = 8 (Sellers Option). (expressed in local time at place of settlement)"
  },
  {
    "tag": "65",
    "name": "SymbolSfx",
    "type": "char",
    "description": "Additional information about the security (e.g. preferred, warrants, etc.). Absence of this field indicates common.\nValid values:\nAs defined in the NYSE Stock and bond Symbol Directory and in the AMEX Fitch Directory"
  },
  {
    "tag": "66",
    "name": "ListID",
    "type": "char",
    "description": "Customer assigned listUnique identifier for list as assigned by institution, used to associate multiple individual orders. Uniqueness must be guaranteed within a single trading day. Firms which generate multi-day orders should consider embedding a date within the ListID field to assure uniqueness across days."
  },
  {
    "tag": "67",
    "name": "ListSeqNo",
    "type": "int",
    "description": "Sequence of individual order within list (i.e. ListSeqNo of ListNoOrds, 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "68",
    "name": "ListNoOrds",
    "type": "int",
    "description": "Total number of orders within list (i.e. ListSeqNo of ListNoOrds, e.g. 2 of 25, 3 of 25, . . . )"
  },
  {
    "tag": "69",
    "name": "ListExecInst",
    "type": "char",
    "description": "Free format text message containing list handling and execution instructions."
  },
  {
    "tag": "70",
    "name": "AllocID",
    "type": "int",
    "description": "Unique identifier for allocation record."
  },
  {
    "tag": "71",
    "name": "AllocTransType",
    "type": "char",
    "description": "Identifies allocation transaction type",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Replace",
        "description": "Replace"
      },
      {
        "value": "2",
        "symbolicName": "Cancel",
        "description": "Cancel"
      }
    ]
  },
  {
    "tag": "72",
    "name": "RefAllocID",
    "type": "int",
    "description": "Reference identifier to be used with Replace and Cancel AllocTransType records."
  },
  {
    "tag": "73",
    "name": "NoOrders",
    "type": "int",
    "description": "Indicates number of orders to be combined for average pricing and allocation."
  },
  {
    "tag": "74",
    "name": "AvgPrxPrecision",
    "type": "int",
    "description": "Indicates number of decimal places to be used for average pricing. Absence of this field indicates that default precision arranged by the broker/institution is to be used."
  },
  {
    "tag": "75",
    "name": "TradeDate",
    "type": "date",
    "description": "Indicates date of trade referenced in this record in YYYYMMDD format. Absence of this field indicates current day (expressed in local time at place of trade)."
  },
  {
    "tag": "76",
    "name": "ExecBroker",
    "type": "char",
    "description": "Identifies executing / give-up broker. Standard NASD market-maker mnemonic is preferred."
  },
  {
    "tag": "77",
    "name": "OpenClose",
    "type": "char",
    "description": "For options only."
  },
  {
    "tag": "78",
    "name": "NoAllocs",
    "type": "int",
    "description": "Number of AllocAccount/AllocShares/ProcessCode instances included in allocation record."
  },
  {
    "tag": "79",
    "name": "AllocAccount",
    "type": "char",
    "description": "Sub-account mnemonic"
  },
  {
    "tag": "80",
    "name": "AllocShares",
    "type": "int",
    "description": "Number of shares to be allocated to specific sub-account"
  },
  {
    "tag": "81",
    "name": "ProcessCode",
    "type": "char",
    "description": "Processing code for sub-account. Absence of this field in AllocAccount / AllocShares / ProcessCode instance indicates regular trade.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Regular",
        "description": "regular"
      },
      {
        "value": "1",
        "symbolicName": "SoftDollar",
        "description": "soft dollar"
      },
      {
        "value": "2",
        "symbolicName": "StepIn",
        "description": "step-in"
      },
      {
        "value": "3",
        "symbolicName": "StepOut",
        "description": "step-out"
      },
      {
        "value": "4",
        "symbolicName": "SoftDollarStepIn",
        "description": "soft-dollar step-in"
      },
      {
        "value": "5",
        "symbolicName": "SoftDollarStepOut",
        "description": "soft-dollar step-out"
      },
      {
        "value": "6",
        "symbolicName": "PlanSponsor",
        "description": "plan sponsor"
      }
    ]
  },
  {
    "tag": "82",
    "name": "NoRpts",
    "type": "int",
    "description": "Total number of reports within series."
  },
  {
    "tag": "83",
    "name": "RptSeq",
    "type": "int",
    "description": "Sequence number of message within report series."
  },
  {
    "tag": "84",
    "name": "CxlQty",
    "type": "int",
    "description": "Total number of shares canceled for this order."
  },
  {
    "tag": "85",
    "name": "NoDlvyInst",
    "type": "int",
    "description": "Number of delivery instruction fields to follow"
  },
  {
    "tag": "86",
    "name": "DlvyInst",
    "type": "char",
    "description": "Free format text field to indicate delivery instructions"
  },
  {
    "tag": "87",
    "name": "AllocStatus",
    "type": "int",
    "description": "Identifies status of allocation.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "Accepted",
        "description": "accepted (successfully processed)"
      },
      {
        "value": "1",
        "symbolicName": "BlockLevelReject",
        "description": "rejected"
      },
      {
        "value": "2",
        "symbolicName": "AccountLevelReject",
        "description": "partial accept"
      },
      {
        "value": "3",
        "symbolicName": "Received",
        "description": "received (received, not yet processed)"
      }
    ]
  },
  {
    "tag": "88",
    "name": "AllocRejCode",
    "type": "int",
    "description": "Identifies reason for rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "UnknownAccount",
        "description": "unknown account(s)"
      },
      {
        "value": "1",
        "symbolicName": "IncorrectQuantity",
        "description": "incorrect quantity"
      },
      {
        "value": "2",
        "symbolicName": "IncorrectAveragegPrice",
        "description": "incorrect average price"
      },
      {
        "value": "3",
        "symbolicName": "UnknownExecutingBrokerMnemonic",
        "description": "unknown executing broker mnemonic"
      },
      {
        "value": "4",
        "symbolicName": "CommissionDifference",
        "description": "commission difference"
      },
      {
        "value": "5",
        "symbolicName": "UnknownOrderID",
        "description": "unknown OrderID"
      },
      {
        "value": "6",
        "symbolicName": "UnknownListID",
        "description": "unknown ListID"
      },
      {
        "value": "7",
        "symbolicName": "OtherSeeText",
        "description": "other"
      }
    ]
  },
  {
    "tag": "89",
    "name": "Signature",
    "type": "data",
    "description": "Electronic signature"
  },
  {
    "tag": "90",
    "name": "SecureDataLen",
    "type": "Length",
    "description": "Length of encrypted message"
  },
  {
    "tag": "91",
    "name": "SecureData",
    "type": "data",
    "description": "Actual encrypted data stream"
  },
  {
    "tag": "92",
    "name": "BrokerOfCredit",
    "type": "char",
    "description": "Broker to receive trade credit"
  },
  {
    "tag": "93",
    "name": "SignatureLength",
    "type": "Length",
    "description": "Number of bytes in signature field."
  },
  {
    "tag": "94",
    "name": "EmailType",
    "type": "char",
    "description": "Email message type.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "New",
        "description": "New"
      },
      {
        "value": "1",
        "symbolicName": "Reply",
        "description": "Reply"
      },
      {
        "value": "2",
        "symbolicName": "AdminReply",
        "description": "Admin Reply"
      }
    ]
  },
  {
    "tag": "95",
    "name": "RawDataLength",
    "type": "Length",
    "description": "Number of bytes in raw data field."
  },
  {
    "tag": "96",
    "name": "RawData",
    "type": "data",
    "description": "Unformatted raw data, can include bitmaps, word processor documents, etc."
  },
  {
    "tag": "97",
    "name": "PossResend",
    "type": "char",
    "description": "Indicates that message may contain information that has been sent under another sequence number."
  },
  {
    "tag": "98",
    "name": "EncryptMethod",
    "type": "int",
    "description": "Method of encryption.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "None / other"
      },
      {
        "value": "1",
        "symbolicName": "PKCS",
        "description": "PKCS (proprietary)"
      },
      {
        "value": "2",
        "symbolicName": "DES",
        "description": "DES (EBC mode)"
      },
      {
        "value": "3",
        "symbolicName": "PKCSDES",
        "description": "PKCS/DES (proprietary)"
      },
      {
        "value": "4",
        "symbolicName": "PGPDES",
        "description": "PGP/DES (defunct)"
      },
      {
        "value": "5",
        "symbolicName": "PGPDESMD5",
        "description": "PGP/DES-MD5 (see app note on FIX home page)"
      },
      {
        "value": "6",
        "symbolicName": "PEM",
        "description": "PEM/DES-MD5 (see app note on FIX home page)"
      }
    ]
  },
  {
    "tag": "99",
    "name": "StopPx",
    "type": "float",
    "description": "Price per share\nValid values:\n0 - 99999999.9999"
  },
  {
    "tag": "100",
    "name": "ExDestination",
    "type": "char",
    "description": "Execution destination as defined by institution when order is entered.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "None",
        "description": "none"
      },
      {
        "value": "4",
        "symbolicName": "POSIT",
        "description": "POSIT"
      }
    ]
  },
  {
    "tag": "102",
    "name": "CxlRejReason",
    "type": "int",
    "description": "Code to identify reason for cancel rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "TooLateToCancel",
        "description": "Too late to cancel"
      },
      {
        "value": "1",
        "symbolicName": "UnknownOrder",
        "description": "Unknown order"
      }
    ]
  },
  {
    "tag": "103",
    "name": "OrdRejReason",
    "type": "int",
    "description": "Code to identify reason for order rejection.",
    "enum": [
      {
        "value": "0",
        "symbolicName": "BrokerCredit",
        "description": "Broker option"
      },
      {
        "value": "1",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "2",
        "symbolicName": "ExchangeClosed",
        "description": "Exchange closed"
      },
      {
        "value": "3",
        "symbolicName": "OrderExceedsLimit",
        "description": "Order exceeds limit"
      },
      {
        "value": "4",
        "symbolicName": "TooLateToEnter",
        "description": "Too late to enter"
      }
    ]
  },
  {
    "tag": "104",
    "name": "IOIQualifier",
    "type": "char",
    "description": "Code to qualify IOI use.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "AllOrNone",
        "description": "All or none"
      },
      {
        "value": "C",
        "symbolicName": "AtTheClose",
        "description": "At the close"
      },
      {
        "value": "I",
        "symbolicName": "InTouchWith",
        "description": "In touch with"
      },
      {
        "value": "L",
        "symbolicName": "Limit",
        "description": "Limit"
      },
      {
        "value": "M",
        "symbolicName": "MoreBehind",
        "description": "More behind"
      },
      {
        "value": "O",
        "symbolicName": "AtTheOpen",
        "description": "At the open"
      },
      {
        "value": "P",
        "symbolicName": "TakingAPosition",
        "description": "Taking a position"
      },
      {
        "value": "Q",
        "symbolicName": "AtTheMarket",
        "description": "Current quote"
      },
      {
        "value": "S",
        "symbolicName": "PortfolioShown",
        "description": "Portfolio show-n"
      },
      {
        "value": "T",
        "symbolicName": "ThroughTheDay",
        "description": "Through the day"
      },
      {
        "value": "V",
        "symbolicName": "Versus",
        "description": "Versus"
      },
      {
        "value": "W",
        "symbolicName": "Indication",
        "description": "Indication - Working away"
      },
      {
        "value": "X",
        "symbolicName": "CrossingOpportunity",
        "description": "Crossing opportunity"
      }
    ]
  },
  {
    "tag": "105",
    "name": "WaveNo",
    "type": "char",
    "description": "Identifier to aid in the management of multiple lists derived from a single, master list."
  },
  {
    "tag": "106",
    "name": "Issuer",
    "type": "char",
    "description": "Company name of security issuer (e.g. International Business Machines)"
  },
  {
    "tag": "107",
    "name": "SecurityDesc",
    "type": "char",
    "description": "Security description."
  },
  {
    "tag": "108",
    "name": "HeartBtInt",
    "type": "int",
    "description": "Heartbeat interval (seconds)"
  },
  {
    "tag": "109",
    "name": "ClientID",
    "type": "char",
    "description": "Firm identifier used in third party-transactions."
  },
  {
    "tag": "110",
    "name": "MinQty",
    "type": "int",
    "description": "Minimum quantity of an order to be executed."
  },
  {
    "tag": "111",
    "name": "MaxFloor",
    "type": "int",
    "description": "Maximum number of shares within an order to be shown on the exchange floor at any given time."
  },
  {
    "tag": "112",
    "name": "TestReqID",
    "type": "char",
    "description": "Identifier included in Test Request message to be returned in resulting Heartbeat"
  },
  {
    "tag": "113",
    "name": "ReportToExch",
    "type": "char",
    "description": "Identifies party of trade responsible for exchange reporting.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SenderReports",
        "description": "Indicates that party sending message will report trade"
      },
      {
        "value": "Y",
        "symbolicName": "ReceiverReports",
        "description": "Indicates that party receiving message must report trade"
      }
    ]
  },
  {
    "tag": "114",
    "name": "LocateReqd",
    "type": "char",
    "description": "Indicates whether the broker is to locate the stock in conjuction with a short sell order.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "No",
        "description": "Indicates the broker is not required to locate"
      },
      {
        "value": "Y",
        "symbolicName": "Yes",
        "description": "Indicates the broker is responsible for locating the stock"
      }
    ]
  },
  {
    "tag": "115",
    "name": "OnBehalfOfCompID",
    "type": "char",
    "description": "Assigned value used to identify firm originating message\nif the message was delivered by a third party i.e. the third party firm identifier would be delivered in the SenderCompID field and the firm originating the message in this field."
  },
  {
    "tag": "116",
    "name": "OnBehalfOfSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message originator (desk, trader, etc.) if the message was delivered by a third party"
  },
  {
    "tag": "117",
    "name": "QuoteID",
    "type": "char",
    "description": "Unique identifier for quote"
  },
  {
    "tag": "118",
    "name": "NetMoney",
    "type": "float",
    "description": "Total amount due as the result of the transaction (e.g. for Buy order - principal + commission + fees) reported in currency of execution."
  },
  {
    "tag": "119",
    "name": "SettlCurrAmt",
    "type": "float",
    "description": "Total amount due expressed in settlement currency (includes the effect of the forex transaction)"
  },
  {
    "tag": "120",
    "name": "SettlCurrency",
    "type": "char",
    "description": "Currency code of settlement denomination."
  },
  {
    "tag": "121",
    "name": "ForexReq",
    "type": "char",
    "description": "Indicates request for forex accommodation trade to be executed along with security transaction.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "DoNotExecuteForexAfterSecurityTrade",
        "description": "Do not execute Forex after security trade"
      },
      {
        "value": "Y",
        "symbolicName": "ExecuteForexAfterSecurityTrade",
        "description": "Execute Forex after security trade"
      }
    ]
  },
  {
    "tag": "122",
    "name": "OrigSendingTime",
    "type": "time",
    "description": "Original time of message transmission (always expressed in GMT) when transmitting orders as the result of a resend request."
  },
  {
    "tag": "123",
    "name": "GapFillFlag",
    "type": "char",
    "description": "Indicates that the Sequence Reset message is replacing administrative or application messages which will not be resent.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "SequenceReset",
        "description": "Sequence Reset, ignore MsgSeqNum"
      },
      {
        "value": "Y",
        "symbolicName": "GapFillMessage",
        "description": "Gap Fill message, MsgSeqNum field valid"
      }
    ]
  },
  {
    "tag": "124",
    "name": "NoExecs",
    "type": "int",
    "description": "No of execution record groups to follow."
  },
  {
    "tag": "125",
    "name": "CxlType",
    "type": "char",
    "description": "Defines if cancel is for part or all of the remaining quantity of an order.",
    "enum": [
      {
        "value": "F",
        "symbolicName": "FullRemainingQuantity",
        "description": "full remaining quantity"
      },
      {
        "value": "P",
        "symbolicName": "PartialCancel",
        "description": "partial cancel (reduce quantity)"
      }
    ]
  },
  {
    "tag": "126",
    "name": "ExpireTime",
    "type": "time",
    "description": "Time/Date of order expiration (always expressed in GMT)"
  },
  {
    "tag": "127",
    "name": "DKReason",
    "type": "char",
    "description": "Reason for execution rejection.",
    "enum": [
      {
        "value": "A",
        "symbolicName": "UnknownSymbol",
        "description": "Unknown symbol"
      },
      {
        "value": "B",
        "symbolicName": "WrongSide",
        "description": "Wrong side"
      },
      {
        "value": "C",
        "symbolicName": "QuantityExceedsOrder",
        "description": "Quantity exceeds order"
      },
      {
        "value": "D",
        "symbolicName": "NoMatchingOrder",
        "description": "No matching order"
      },
      {
        "value": "E",
        "symbolicName": "PriceExceedsLimit",
        "description": "Price exceeds limit"
      },
      {
        "value": "Z",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "128",
    "name": "DeliverToCompID",
    "type": "char",
    "description": "Assigned value used to identify the firm targeted to receive the message if the message is delivered by a third party i.e. the third party firm identifier would be delivered in the TargetCompID field and the ultimate receiver firm ID in this field."
  },
  {
    "tag": "129",
    "name": "DeliverToSubID",
    "type": "char",
    "description": "Assigned value used to identify specific message recipient (desk, trader, etc.) if the message is delivered by a third party"
  },
  {
    "tag": "130",
    "name": "IOINaturalFlag",
    "type": "char",
    "description": "Indicates that IOI is the result of an existing agency order or a facilitation position resulting from an agency order, not from principal trading or order solicitation activity.",
    "enum": [
      {
        "value": "N",
        "symbolicName": "NotNatural",
        "description": "Not natural"
      },
      {
        "value": "Y",
        "symbolicName": "Natural",
        "description": "Natural"
      }
    ]
  },
  {
    "tag": "131",
    "name": "QuoteReqID",
    "type": "char",
    "description": "Unique identifier for quote request"
  },
  {
    "tag": "132",
    "name": "BidPx",
    "type": "float",
    "description": "Bid price/rate"
  },
  {
    "tag": "133",
    "name": "OfferPx",
    "type": "float",
    "description": "Offer price/rate"
  },
  {
    "tag": "134",
    "name": "BidSize",
    "type": "int",
    "description": "Quantity of bid"
  },
  {
    "tag": "135",
    "name": "OfferSize",
    "type": "int",
    "description": "Quantity of offer"
  },
  {
    "tag": "136",
    "name": "NoMiscFees",
    "type": "int",
    "description": "Number of repeating groups of miscellaneous fees"
  },
  {
    "tag": "137",
    "name": "MiscFeeAmt",
    "type": "float",
    "description": "Miscellaneous fee value"
  },
  {
    "tag": "138",
    "name": "MiscFeeCurr",
    "type": "char",
    "description": "Currency of miscellaneous fee"
  },
  {
    "tag": "139",
    "name": "MiscFeeType",
    "type": "char",
    "description": "Indicates type of miscellaneous fee.",
    "enum": [
      {
        "value": "1",
        "symbolicName": "Regulatory",
        "description": "Regulatory (e.g. SEC)"
      },
      {
        "value": "2",
        "symbolicName": "Tax",
        "description": "Tax"
      },
      {
        "value": "3",
        "symbolicName": "LocalCommission",
        "description": "Local Commission"
      },
      {
        "value": "4",
        "symbolicName": "ExchangeFees",
        "description": "Exchange Fees"
      },
      {
        "value": "5",
        "symbolicName": "Stamp",
        "description": "Stamp"
      },
      {
        "value": "6",
        "symbolicName": "Levy",
        "description": "Levy"
      },
      {
        "value": "7",
        "symbolicName": "Other",
        "description": "Other"
      }
    ]
  },
  {
    "tag": "140",
    "name": "PrevClosePx",
    "type": "float",
    "description": "Previous closing price of security."
  }
]
